export enum PreviewMode {
    Text,
    Python,
    Image,
    Unknown,
    Svg,
    Pdf,
    Object
}